import { render, staticRenderFns } from "./Settlement.vue?vue&type=template&id=3d1c166f&scoped=true"
import script from "./Settlement.vue?vue&type=script&lang=js"
export * from "./Settlement.vue?vue&type=script&lang=js"
import style0 from "./Settlement.vue?vue&type=style&index=0&id=3d1c166f&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d1c166f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pagsmile/front-end/pagsmile-dashboard/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3d1c166f')) {
      api.createRecord('3d1c166f', component.options)
    } else {
      api.reload('3d1c166f', component.options)
    }
    module.hot.accept("./Settlement.vue?vue&type=template&id=3d1c166f&scoped=true", function () {
      api.rerender('3d1c166f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Settlement/Settlement.vue"
export default component.exports